export default __webpack_public_path__ + "static/media/strength_vicop_en.39389486.png";